export default class AuthUser {
  constructor (user) {
    this.user = user
  }

  can (permission) {
    return this.user.permissions.includes(permission)
  }

  setUser (user) {
    this.user = user
  }

  user () {
    return this.user
  }
}
